<template>
    <div class="wrap">
        <van-notify v-model="showTips" duration="0" :type="tipsType">
            <van-icon name="info-o" style="margin-right: 4px;" />
            <span>{{ tipsTitle }}{{ tipsConteant }}</span>
        </van-notify>
        <div class="title">提交认证资料</div>
        <van-form>
            <van-field
                required
                v-model="field.name"
                :readonly="readonly"
                label="姓名"
                placeholder="请输入"
            />
            <van-field required v-model="field.phone" label="手机号" placeholder="请输入" />
            <van-field
                readonly
                clickable
                is-link
                required
                v-model="field.sex"
                label="性别"
                placeholder="请选择"
                @click="selectPicker('sex')"
            />
            <van-field
                required
                v-model="field.age"
                type="number"
                label="年龄"
                :readonly="readonly"
                placeholder="请输入"
            />
            <van-field
                required
                v-model="field.company"
                :readonly="readonly"
                label="单位"
                placeholder="请输入"
            />
        </van-form>
        <div class="box">
            <div class="title">友情提示</div>
            <div class="content">提交资料后管理员审核通过后即可拥有报名资格，请注意微信通知</div>
        </div>
        <div class="btn-wrap" v-if="!readonly">
            <van-button round block type="primary" @click="onSubmit">立即认证</van-button>
        </div>
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                title=""
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
        </van-popup>
    </div>
</template>
<script>
import { postVerified, getVerified } from '@api/user';
import { mapGetters } from 'vuex';
import { empty } from '@utils';
export default {
    name: 'Authenticate',
    data() {
        return {
            field: {
                name: '',
                phone: '',
                sex: '',
                age: '',
                company: ''
            },
            showPicker: false,
            columns: [],
            curField: '',
            tipsConteant: '',
            showTips: false,
            tipsType: 'success',
            tipsTitle: '',
            readonly: false
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    watch: {
        $route(n) {
            if (n.name === 'Authenticate') {
                this.$set(this.field, 'name', '');
                this.$set(this.field, 'phone', '');
                this.$set(this.field, 'sex', '');
                this.$set(this.field, 'age', '');
                this.$set(this.field, 'company', '');
                this.getInfo();
            }
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        onSubmit() {
            let that = this;
            if (empty(this.field.name)) return this.$dialog.error('请填写姓名');
            if (empty(this.field.phone)) return this.$dialog.error('请填写手机号');
            if (empty(this.field.sex)) return this.$dialog.error('请选择性别');
            if (empty(this.field.age)) return this.$dialog.error('请填写年龄');
            if (empty(this.field.company)) return this.$dialog.error('请填写单位');
            this.$dialog.loading('提交中...');
            postVerified(this.field)
                .then(res => {
                    return that.$dialog.close().then(() => {
                        that.$dialog.success(res.msg).then(() => {
                            that.$router.replace({ path: '/user' });
                        });
                    });
                })
                .catch(err => {
                    return that.$dialog.close().then(() => {
                        that.$dialog.error(err);
                    });
                });
        },
        onConfirm(value) {
            this.$set(this.field, this.curField, value);
            this.$set(this, 'showPicker', false);
            this.$set(this, 'curField', '');
        },
        selectPicker(field) {
            this.$set(this, 'curField', field);
            switch (field) {
                case 'sex':
                    this.$set(this, 'columns', ['男', '女']);
                    break;
            }
            this.$set(this, 'showPicker', true);
        },
        getInfo() {
            let that = this;
            getVerified().then(res => {
                if (res.data.id) {
                    that.$set(that, 'field', res.data);

                    if (res.data.status == 2) {
                        this.showTips = true;
                        this.tipsTitle = '审核失败';
                        this.tipsConteant = res.data.review_reason || '审核失败，请重新提交';
                        this.tipsType = 'warning';
                        this.readonly = false;
                    } else if (res.data.status == 1) {
                        this.showTips = true;
                        this.tipsTitle = '审核通过';
                        this.tipsType = 'success';
                        this.readonly = true;
                    } else {
                        this.showTips = true;
                        this.tipsTitle = '正在审核中';
                        this.tipsType = 'primary';
                        this.readonly = true;
                    }
                }
            });
        }
    }
};
</script>
